import { atom } from 'jotai';
import { $SharingPageLevelTraffic, $UserDetail, IUserPageTraffic } from 'shared/atoms';
import { EPageType } from 'shared/constant';
import { IUserDetail, UserDetailUtil } from 'shared/models';
import { Unreachable } from '@lemon8/web-app-shared/util';

export const CurrentUserId = atom((get) => {
  const traffic = get($SharingPageLevelTraffic);
  const { pageType } = traffic;

  if (pageType !== EPageType.USER) {
    Unreachable(`invalid page type: ${pageType}`);
  }

  const userTraffic = traffic as IUserPageTraffic;

  return userTraffic.userId;
});

export const $CurrentUserLinkName = atom((get) => {
  const traffic = get($SharingPageLevelTraffic);
  const { pageType } = traffic;

  if (pageType !== EPageType.USER) {
    Unreachable(`invalid page type: ${pageType}`);
  }

  const userTraffic = traffic as IUserPageTraffic;

  return userTraffic.userLinkName;
});

export const $CurrentUser = atom((get) => {
  const currentUserLinkName = get($CurrentUserLinkName);
  return get($UserDetail(currentUserLinkName));
});

export const $CurrentUserOrNull = atom(async (get) => {
  const user = await get($CurrentUser);
  return UserDetailUtil.isUserAvailable(user) ? user : null;
});

export const $CurrentUserAsAvailable = atom(async (get) => {
  const user = await get($CurrentUser);
  return user as IUserDetail;
});
